<template>
  <!-- Global notification live region -->
  <div aria-live="assertive" class="pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-end sm:p-6 z-50">
    <div class="flex w-full flex-col items-center space-y-4 sm:items-end">
      <!-- Notification panels -->
      <TransitionGroup
        enter-active-class="transform ease-out duration-300 transition"
        enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
        enter-to-class="translate-y-0 sm:translate-x-0"
        leave-active-class="transition ease-in duration-100"
        leave-to-class="opacity-0"
      >
        <div
          v-for="toast in toasts"
          :key="toast.id"
          class="pointer-events-auto w-full max-w-sm rounded-lg border-2 bg-white shadow-lg outline-1 outline-black/5 dark:bg-gray-800 dark:-outline-offset-1 dark:outline-white/10"
          :class="toast.type"
        >
          <div class="p-4">
            <div class="flex items-start">
              <div class="shrink-0">
                <CheckCircleIcon v-if="toast.type === 'success'" class="w-6 h-6 text-green-400" aria-hidden="true" />
                <ExclamationCircleIcon v-else-if="toast.type === 'warning'" class="w-6 h-6 text-yellow-400" aria-hidden="true" />
                <XCircleIcon v-else-if="toast.type === 'error'" class="w-6 h-6 text-red-400" aria-hidden="true" />
                <InformationCircleIcon v-else class="w-6 h-6 text-blue-400" aria-hidden="true" />
              </div>
              <div class="ml-3 w-0 flex-1 pt-0.5">
                <p class="text-sm font-medium text-gray-900 dark:text-white">{{ toast.title }}</p>
                <p v-if="toast.message" class="mt-1 text-sm text-gray-500 dark:text-gray-400">{{ toast.message }}</p>
              </div>
              <div class="ml-4 flex shrink-0">
                <button
                  type="button"
                  @click="removeToast(toast.id)"
                  class="inline-flex rounded-md text-gray-400 hover:text-gray-500 focus:outline-2 focus:outline-offset-2 focus:outline-indigo-600 dark:hover:text-white dark:focus:outline-indigo-500"
                >
                  <span class="sr-only">Close</span>
                  <XIcon class="w-5 h-5" aria-hidden="true" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </TransitionGroup>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import {
  CheckCircleIcon,
  ExclamationCircleIcon,
  XCircleIcon,
  InformationCircleIcon,
  XIcon,
} from '@heroicons/vue/outline'

export default {
  name: 'ToastNotification',
  components: {
    CheckCircleIcon,
    ExclamationCircleIcon,
    XCircleIcon,
    InformationCircleIcon,
    XIcon,
  },
  setup () {
    const store = useStore()

    const toasts = computed(() => store.state.toast.toasts)

    const removeToast = (id) => {
      store.dispatch('toast/remove', id)
    }

    return {
      toasts,
      removeToast,
    }
  },
}
</script>

<style scoped>
  .success {
    border-color: rgb(100, 255, 100);
  }
  .error {
    border-color: rgb(255, 100, 100);
  }
</style>
